import { ReferenceInput, SelectInput } from "react-admin";

import React from "react";

const LanguageInput = (props) => (
  <ReferenceInput {...props} reference="language">
    <SelectInput optionText="name" />
  </ReferenceInput>
);
export default LanguageInput;
